import React from 'react';
import s from './s.module.less';
import PageManagement from './components/PageManagement';
import { PermissionModuleKeys } from 'constants/access';
import AccessDenied from 'components/AccessDenied';
import AccessStore from 'store/Access/permission';

const IntakeWorkflowsPage = () => {
    const [getAccessStore] = AccessStore.useStore();
    const access = getAccessStore('data');

    return (
        <div className={s.wrap}>
            <div className={s.content}>
                {access?.[PermissionModuleKeys.KLARITY_ASSESSMENT] ? (
                    <div>
                        <h3 className={s.subtitle}>Intake workflows</h3>
                        {access?.[PermissionModuleKeys.TEXT_VISIT_WORKFLOWS] ? (
                            <PageManagement />
                        ) : (
                            <AccessDenied />
                        )}
                    </div>
                ) : (
                    <AccessDenied />
                )}
            </div>
        </div>
    );
};

export default IntakeWorkflowsPage;


